import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface VmsAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const VmsAccordion: React.FC<VmsAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('job');

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : 'N/A';

  const mappedData = {
    vMSNameID: striive_job ? getValue(striive_job.broker) : 'N/A',
    vMSMapID: striive_job ? getValue(striive_job.broker_slug) : 'N/A',
    fyreSync: 'N/A',
    vMSRegID: 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title={t('v2.accordion.vms')} expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem(t('v2.accordion.fyreSyncRequisition'), mappedData.fyreSync)}
        {renderDetailItem(t('v2.accordion.vmsNameId'), mappedData.vMSNameID)}
        {renderDetailItem(t('v2.accordion.vmsRegId'), mappedData.vMSRegID)}
        {renderDetailItem(t('v2.accordion.vmsMapId'), mappedData.vMSMapID)}
      </Grid>
    </JobAccordion>
  );
};
